import React, { useRef, useState } from "react";
import "../styles/portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import FaqQuestion from "./elements/faqquestion";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { EffectCards } from "swiper/modules";
import "swiper/css/effect-cards";
import Tilt from "react-parallax-tilt";
import { Parallax, Pagination, Navigation, Autoplay } from "swiper/modules";
import PortfolioNavbar from "./elements/portfolionavbar";
import TestimonialsRow from "./elements/testimonialsrow";
import { useNavigate } from "react-router-dom";

import PortfolioFooter from "./elements/portfoliofooter";
import { useGetAllBlogsQuery } from "../store/General/generalSlice";
import { FaLaptopMedical } from "react-icons/fa6";
import GrowWithNeurogen from "./elements/growwithneurogen";
import PortfolioBanner from "./elements/portfoliobanner";
import PortfolioFaq from "./elements/portfoliofaq";
import FeatureElement from "./elements/featureelement";

const Mockupicon1 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/homeicon/mockup1.svg";
const Mockupicon2 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/homeicon/mockup2.svg";
const Mockupicon3 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/homeicon/mockup3.svg";
const Mockupgrid1 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/homeicon/mockupgrid1.svg";

const Mockupgrid2 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/homeicon/mockupgrid2.svg";
const Mockupgrid3 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/homeicon/mockupgrid3.svg";
const Logo =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logo.svg";
const HomeScreen =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/bannerfinal.svg";
const explore1image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/img.svg";
const explore2image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore2.svg";
const explore3image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore3.svg";

const explore4image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore4.svg";
const bottomleftone =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsbottomleft.svg";

const blogIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/blog.svg";
const literatureIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/literature.svg";
const supportIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/support.svg";

const newsIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/news.svg";

const offersIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/offer.svg";
const starIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/star.svg";
const focusIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/focus.svg";
const explore1imagemobile =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore1mobile.svg";
const explore2imagemobile =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore2mobile.svg";
const explore3imagemobile =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore3mobile.svg";
const explore4imagemobile =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore4mobile.svg";
const CustomizeIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/customize.svg";
const heartIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/heart.svg";
export default function Home() {
  const navigate = useNavigate();
  const {
    data: allBlogs,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetAllBlogsQuery();

  const slideDescriptions = [
    "Clincal Case Simulation",
    "Differential Diagnosis",
    "Image Based Diagnosis",
  ];
  const [activeIndex, setActiveIndex] = useState(0);
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex); // Update the active index
  };
  const [selectedFeature, setSelectedFeature] = useState(0); // Track selected feature index

  const features = [
    {
      question: "AI Query System: Answers at the Speed of Thought",
      answer:
        "No more endless searching. Ask NeuroGEN any medical question, and receive immediate, evidence-based answers that are clear, concise, and clinically sound.",
    },
    {
      question: "Quick Search and Quick Notes",
      answer:
        "Get accurate medical answers and downloadable notes instantly, all in one prompt—quick, reliable, and hassle-free!",
    },
    {
      question: "Clinical Simulations: Practice That Feels Real",
      answer:
        "Prepare for the toughest exams—USMLE, PLAB, AIIMS, NEET PG—using immersive AI-powered simulations that mirror real-life medical scenarios. NeuroGEN helps you practice like it’s the real thing.",
    },
    {
      question: "Differential Dx: Unlock the Secrets of Diagnosis",
      answer:
        "With every symptom, every data point, NeuroGEN cuts through the noise, revealing hidden patterns and delivering fast, accurate differential diagnoses.",
    },
  ];
  const images = [
    explore1imagemobile,
    explore2imagemobile,
    explore3imagemobile,
    explore4imagemobile,
  ];
  return (
    <div className="portfolio">
      <div className="portfoliopadding">
        <div className="homenotice">
          <p>Want to create history,</p>
          <p>
            <u onClick={() => navigate("/register/email")}>
              Join Neuroverse Healthcare
            </u>
          </p>
        </div>
        <div className="portfoliohome">
          <PortfolioNavbar colortheme="blue" />
          <div className="portfoliohomebody">
            <div className="portfoliohomebodyleft">
              <h1>
                {/* Welcome to The Future of Healthcare */}
                {/* <img src={Logo} alt="Logo" /> */}
                {/* YOUR ULTIMATE{" "} */}
                {/* <strong>MED</strong>-GUIDE */}
                Smart
                <br /> Adaptive
                <br /> Revolutionary
              </h1>
              <p>Revolutionising how you study, Diagnose, & Master Medicine.</p>
              <button onClick={() => navigate("/register/email")}>
                Start Now
              </button>
            </div>
            <div className="portfoliohomebodyright">
              <Tilt tiltMaxAngleX={5} tiltMaxAngleY={5}>
                <img
                  src={HomeScreen}
                  alt="Home Screen"
                  className="homescreenview"
                />
              </Tilt>
            </div>
          </div>
        </div>
      </div>
      <div className="portfolioexplore mobileonly noipad" id="features">
        <h2 className="h2headerportfolio">
          Explore the Core Features of NeuroGEN
        </h2>
        <p className="portfolioexploretext">
          Collaborate with a seamless blend of AI and medical expertise. Whether
          you’re diagnosing, researching, or learning, Neurogen empowers you to
          reach new heights with speed and accuracy.
        </p>
        {/* <div className="explorerow ">
          <Swiper
            slidesPerView={3}
            spaceBetween={20}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            centeredSlides={true}
            initialSlide={1}
            className="mySwiper desktoponly ipadonly"
            onSlideChange={handleSlideChange}
            onSwiper={(swiper) => handleSlideChange(swiper)}
          >
            {[explore2image, explore3image, explore4image].map((img, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`exploreimage`}
                  style={{
                    opacity: activeIndex === index ? "1" : "0.6",
                    margin:
                      activeIndex !== index ? "40px 0px 20px 0px" : " 0 0 0 0",
                    transition: "all 0.5s ease-in-out",
                  }}
                >
                  <img src={img} alt={`Explore ${index + 2}`} />{" "}
                  {activeIndex === index && (
                    <p className="featurename">{slideDescriptions[index]}</p>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div> */}
        <div className="portfoliofeaturesmain hidden">
          <div className="portfoliofeaturesmainbody">
            <div className="portfoliofeaturesmainbodyleft">
              {features.map((feature, index) => (
                <FeatureElement
                  key={index}
                  selected={selectedFeature === index}
                  question={feature.question}
                  answer={feature.answer}
                  onClick={() => setSelectedFeature(index)}
                />
              ))}
            </div>
            <div className="portfoliofeaturesmainbodyright">
              <img src={images[selectedFeature]} alt="Heart" />
            </div>
          </div>
        </div>

        <div className=" noipad mobileonly portfoliocards">
          <Swiper
            effect={"cards"}
            grabCursor={true}
            modules={[EffectCards]}
            className="mySwiper swiperportfolio"
            initialSlide={1}
          >
            {[
              explore2imagemobile,
              explore3imagemobile,
              explore4imagemobile,
            ].map((img, index) => (
              <SwiperSlide className="setwidth" key={index}>
                <img src={img} alt={`Explore ${index + 2}`} />{" "}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* <div className="dashboardgridmobile noipad mobileonly">
            <Swiper
              effect={"cards"}
              grabCursor={true}
              modules={[EffectCards]}
              className="mySwiper"
              initialSlide={1}
            >
              {[explore2image, explore3image, explore4image].map(
                (img, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className={`exploreimage exploreimageslider`}
                      style={{
                        opacity: activeIndex === index ? "1" : "0.6",
                        margin:
                          activeIndex !== index
                            ? "40px 0px 20px 0px"
                            : " 0 0 0 0",
                        transition: "all 0.5s ease-in-out",
                      }}
                    >
                      <img src={img} alt={`Explore ${index + 2}`} />{" "}
                      {activeIndex === index && (
                        <p className="featurename">
                          {slideDescriptions[index]}
                        </p>
                      )}
                    </div>
                  </SwiperSlide>
                )
              )}
            </Swiper>
          </div> */}
      </div>

      {/* <div className="gradientdiv exploregradient">
          <h4>Instant Answers, Expertly Curated</h4>
          <p>
            In the fast-paced world of healthcare, timely and accurate
            information is critical. NeuroGEN’s Query System is your go-to
            resource for medical inquiries. Leveraging the latest in AI
            technology, it provides instant, evidence-based answers to your
            questions, ensuring that you have the information you need, exactly
            when you need it.
          </p>
        </div> */}
      <div className="portfoliopadding">
        <div className="portfoliostats">
          <h2 className="h2headerportfolio ">
            Leading The Future of Medical Education Worldwide!{" "}
          </h2>
          <div className="portfoliostatsgrid">
            <div className="portfoliostatsgridleft">
              <div className="portfoliostatsgridlefttop"></div>
              <div className="portfoliostatsgridleftbottom">
                <div className="portfoliostatsgridleftbottomleft gradientdiv">
                  <h2>Over 1.2Mil Users</h2>
                  <p>
                    Including Leading Medical Professionals, students, and
                    researchers, rely on NeuroGEN for cutting-edge medical
                    insights and assistance.
                  </p>
                </div>
                <div className="portfoliostatsgridleftbottomright">
                  <div className="portfoliostatsgridleftbottomrightone statsquarediv gradientdiv">
                    <img src={bottomleftone} alt="Medical" />
                    <p>Solve Medical Queries</p>
                  </div>
                  <div className="desktoponly portfoliostatsgridleftbottomrighttwo gradientdiv statsminidiv w-full">
                    <img src={blogIcon} alt="Blog" />
                    <h5>Blog</h5>
                    <p>
                      Revolutionizing Healthcare: How AI, Advanced Imaging, and
                      Data-Driven Insights Are Transforming Medical Diagnosis,
                      Research, and Patient Care
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="portfoliostatsgridcontentrightstretch">
              <div className="portfoliostatsgridright">
                <div className="portfoliostatsgridrightone">
                  <div className="portfoliostatsgridrightonetop">
                    <h4>+130%</h4>
                    <div className="portfoliostatsgridrightonetopcontent">
                      <h5>Efficiency</h5>
                      <p>
                        Enhance your efficiency by 130% in diagnosis, research,
                        and learning with Neurogen's' cutting-edge capabilities
                      </p>
                    </div>
                  </div>
                  <div className="portfoliostatsgridrightonebottom statsquarediv gradientdiv">
                    <img src={Mockupgrid1} alt="Medical" />
                    <p>Analyze Radiologic, EEG, ECG & Pathological Images</p>
                  </div>
                </div>
                <div className="portfoliostatsgridrighttwo">
                  <div className="portfoliostatsgridrighttwotop statsquarediv gradientdiv">
                    <img src={Mockupgrid2} alt="Medical" />
                    <div className="statssquaredivcontent">
                      <p>Clinical Case Simulation</p>
                      <p
                        className="statspreview"
                        onClick={() => navigate("/clinical")}
                      >
                        See Preview{" "}
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                      </p>
                    </div>
                  </div>
                  <div className="portfoliostatsgridrighttwocenter statsquarediv gradientdiv">
                    <img src={Mockupgrid3} alt="Medical" />
                    <div className="statssquaredivcontent">
                      <p>Assist in Diagnosing Diseases</p>
                    </div>
                  </div>
                  <div className="portfoliostatsgridrighttwobottom desktoponly gradientdiv statsminidiv heightfull">
                    <img src={newsIcon} alt="News" />
                    <h5>Newsletter</h5>
                    <p>
                      Stay ahead in medical innovation—explore the latest
                      breakthroughs in diagnostics, AI-driven research, and
                      patient care with NeuroGEN.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="portfoliostatsgridbottom desktoponly">
            <div className="portfoliostatsgridbottomcard statsminidiv gradientdiv ">
              <img src={offersIcon} alt="Offers" />
              <h5>Offer Case Simulations</h5>
              <p>
                Sharpen your skills with realistic case challenges and
                simulations.
              </p>
            </div>
            <div className="portfoliostatsgridbottomcard statsminidiv gradientdiv ">
              <img src={supportIcon} alt="Support" />
              <h5>Support Medical Research</h5>
              <p>
                Let Neurogen aid and enhance your research efforts with advanced
                tools.
              </p>
            </div>
            <div className="portfoliostatsgridbottomcard statsminidiv gradientdiv ">
              <img src={literatureIcon} alt="Literature" />
              <h5>Literature Review</h5>
              <p>
                Get accurate and reliable answers for all your medical related
                queries.
              </p>
            </div>
            <div className="portfoliostatsgridbottomcard statsminidiv gradientdiv ">
              <img src={offersIcon} alt="Patient" />
              <h5>Patient Data Analysis</h5>
              <p>
                Leverage Neurogen to analyze and derive valuable insights from
                patient.
              </p>
            </div>
          </div>
        </div>

        <div className="portfolioresearch" id="innovations">
          <h2 className="h2headerportfolio">Ongoing Research</h2>
          <h5>Charting a Bold New Path in Medicine</h5>
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            speed={600}
            parallax={true}
            pagination={{
              clickable: true,
            }}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            navigation={true}
            modules={[Parallax, Pagination, Navigation, Autoplay]}
            className="mySwiper"
          >
            <div
              slot="container-start"
              className="parallax-bg portfolioparallax"
              data-swiper-parallax="-23%"
            ></div>
            <SwiperSlide>
              <div className="title" data-swiper-parallax="-300">
                AI-Powered Personalized Artificial Heart
              </div>
              {/* 
              <div className="text" data-swiper-parallax="-100">
                <p>
                  Imagine a heart that learns, adapts, and evolves with you.
                  NeuroGEN’s AI-powered artificial heart is personalized to each
                  patient, providing dynamic cardiovascular support for a
                  longer, healthier life.
                </p>
              </div> */}
            </SwiperSlide>
            <SwiperSlide>
              <div className="title" data-swiper-parallax="-300">
                Project NEPHRA
              </div>
              {/* <div className="subtitle" data-swiper-parallax="-200">
                The Future of Renal Care
              </div>
              <div className="text" data-swiper-parallax="-100">
                <p>
                  NeuroGEN’s AI-powered personalized artificial kidney takes
                  kidney care to a new level, offering seamless integration with
                  the body’s processes and real-time adaptability to improve
                  patient outcomes.
                </p>
              </div> */}
            </SwiperSlide>
            <SwiperSlide>
              <div className="title" data-swiper-parallax="-300">
                Project TargetOnco
              </div>
              {/* <div className="subtitle" data-swiper-parallax="-200">
                Precision Oncology Redefined
              </div>
              <div className="text" data-swiper-parallax="-100">
                <p>
                  Cancer doesn’t play by the rules, but with Project TargetOnco,
                  you’ll stay one step ahead. Using AI to tailor treatments
                  based on a patient’s genetic profile, we’re delivering
                  personalized, targeted cancer therapies that promise new hope.
                </p>
              </div> */}
            </SwiperSlide>
            <SwiperSlide>
              <div className="title" data-swiper-parallax="-300">
                Project AntiMicrob
              </div>
              {/* <div className="subtitle" data-swiper-parallax="-200">
                Winning the War on Superbugs
              </div>
              <div className="text" data-swiper-parallax="-100">
                <p>
                  Cancer doesn’t play by the rules, but with Project TargetOnco,
                  you’ll stay one step ahead. Using AI to tailor treatments
                  based on a patient’s genetic profile, we’re delivering
                  personalized, targeted cancer therapies that promise new hope.
                </p>
              </div> */}
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className="portfoliotestimonials">
        <h2 className="h2headerportfolio">Loved by Innovators</h2>
        <div className="portfoliotestimonialsrow">
          <TestimonialsRow />
        </div>
      </div>
      <div className="portfoliopadding">
        <PortfolioFaq />
        <p className="portfoliosubline">
          Still have questions?{" "}
          <a onClick={() => navigate("/faq")}>Read More Here</a>
        </p>
        <GrowWithNeurogen />

        <PortfolioBanner />
        <PortfolioFooter />
      </div>
    </div>
  );
}
